import { ref, listAll, getDownloadURL, getMetadata, FullMetadata } from "firebase/storage"
import { filesStorage } from "../firebase"
import { FileData } from "../../components/atoms/FileItem"
import { format } from "date-fns"

const formatDateWithOrdinal = (dateString: string): string => {
  const date = new Date(dateString)

  return format(date, "MMM do")
}

const getFileType = (metadata: FullMetadata) => {
  const isImage = metadata.contentType?.startsWith("image/")

  if (metadata.customMetadata?.type === "booking-confirmation") return "confirmation"

  return isImage ? "image" : "document"
}

export const getFilesWithMetadata = async (tripId: string): Promise<FileData[]> => {
  const imagesListRef = ref(filesStorage, `files/${tripId}/`)
  const confirmationListRef = ref(filesStorage, `files/${tripId}/booking-confirmations/`)

  try {
    const [response, confirmationResponse] = await Promise.all([
      listAll(imagesListRef),
      listAll(confirmationListRef),
    ])

    const files = [...response.items, ...confirmationResponse.items]

    const filePromises = files.map(async (item) => {
      const url = await getDownloadURL(item)
      const metadata = await getMetadata(item)
      const isImage = metadata.contentType?.startsWith("image/")

      return {
        thumbnail: isImage ? url : undefined,
        fileName: metadata.customMetadata?.fileName || item.name,
        fileURL: url,
        uploadDate: formatDateWithOrdinal(metadata.timeCreated),
        timeCreated: metadata.timeCreated,
        sharedBy: metadata.customMetadata?.username || "Unknown",
        userId: metadata.customMetadata?.userId || "",
        type: getFileType(metadata),
      }
    })

    const filesWithMetadata = await Promise.all(filePromises)

    filesWithMetadata.sort(
      (a, b) => new Date(b.timeCreated).getTime() - new Date(a.timeCreated).getTime(),
    )

    return filesWithMetadata as FileData[]
  } catch (error) {
    console.error("Error retrieving files:", error)
    return []
  }
}
